import { useState, useCallback } from "react"
import { useTranslation } from "react-i18next"
import { IconBellSearch } from "@tabler/icons-react"
import { FilteredRemindersModal } from "@/routes/-components/reminders/filtered-reminders-modal"

export function useGetReminderListMenuItemProps() {
  const { t } = useTranslation("app_server")
  const [opened, setOpened] = useState(false)

  const handleOpen = useCallback(() => setOpened(true), [])
  const handleClose = useCallback(() => setOpened(false), [])

  const menuItem = {
    children: t("AllReminders") as string,
    leftSection: <IconBellSearch size={16} />,
    onClick: handleOpen,
  }

  const modal = <FilteredRemindersModal opened={opened} onClose={handleClose} />

  return { menuItem, modal }
}
